import { RouteObject } from "react-router-dom";

export const warrantiesRoutes: RouteObject[] = [
  {
    lazy: async () => {
      const { Page } = await import("../login/page");

      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        path: "",
        lazy: async () => {
          const { Page } = await import("../order/page");
          const { ThirdPartyWarranty } = await import(
            "../order/recycling/third-party-warranty"
          );
          return {
            element: (
              <Page>
                <ThirdPartyWarranty />
              </Page>
            ),
          };
        },
      },
      {
        path: "register",
        lazy: async () => {
          const { RegisterWarranty } = await import("./register-warranty");
          const { Page } = await import("../order/page");
          return {
            element: (
              <Page>
                <RegisterWarranty />
              </Page>
            ),
          };
        },
      },
      {
        path: ":warrantyId/warranty",
        lazy: async () => {
          const { Main } = await import(
            "@redotech/redo-customer-portal-app/portal-four/submission/main"
          );
          const { Page } = await import("../order/page");
          return {
            element: (
              <Page>
                <Main />
              </Page>
            ),
          };
        },
      },
      {
        path: "recycle-start",
        lazy: async () => {
          const { Main } = await import(
            "@redotech/redo-customer-portal-app/portal-four/submission/main"
          );
          const { Page } = await import("../order/page");
          return {
            element: (
              <Page>
                <Main />
              </Page>
            ),
          };
        },
      },
      {
        path: ":warrantyId/details",
        lazy: async () => {
          const { RegisteredWarrantyDetails } = await import(
            "./registered-warranty-details"
          );
          const { Page } = await import("../order/page");
          return {
            element: (
              <Page>
                <RegisteredWarrantyDetails />
              </Page>
            ),
          };
        },
      },
    ],
  },
];
